import { render } from "./OrderForm.vue?vue&type=template&id=7d051655"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
script.render = render

export default script